import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import Section from '../section';
import APIKeys from '../api-keys/api-keys';
import InvocationsStats from './invocations-stats/invocations-stats';
import WebhooksListing from './webhooks-listing';
import WebhooksDeadLetterListing from './deadletter/deadletter-queue';


function WebhooksDashboard() {
  return (
    <div className="content-container">
        <Alert severity='warning' sx={{mb: 2}}>This feature is currently in Beta/Technical Preview. Contact us for any related questions.</Alert>
                <Grid2 spacing={2} container alignItems="stretch">
                  <Grid2 xs={12} md={12} display="flex">
                    <Section title="Webhook Registration">
                      <WebhooksListing />
                    </Section>
                  </Grid2>
                   <Grid2 xs={12} md={12} display="flex">
                    <Section title="Webhook Invocation History">
                      <InvocationsStats />
                    </Section>
                  </Grid2>
                   <Grid2 xs={12} md={12} display="flex">
                    <Section title="Webhooks Deadletter Queue">
                      <WebhooksDeadLetterListing />
                    </Section>
                  </Grid2>
                  
                </Grid2>
    </div>
  );
}

export default WebhooksDashboard;
